import React, {useState} from 'react';
import {TextAreaField} from "../FormField";
import Button, {BUTTON_VARIANTS} from "../../components2/UI/Button/Button";
import "./Report.scss";
import Group from "../../components2/UI/Group/Group";


const Report = ({
        handleReport = () =>{},
        handleClose = () =>{}
    }) =>{

    const [message, setMessage] = useState("");

    return (
        <div className="report">
            <div className={"report-container"}>
                <p className={"report-container-text"}>Signalez ici un comportement ou contenu qui ne respecte pas la charte de notre
                    communauté</p>
                <p className="report-container-text report-warning"><b>Donnez nous un maximum d’informations pour que nous puissions
                    agir:</b></p>
                <TextAreaField placeholder={"Raison de votre signalement ..."}
                               value={message}
                               onChange={(event)=>setMessage(event.target.value)}/>
            </div>
            <div className={"report-footer"}>
                <Group>
                    <Button
                        onClick={() => handleClose()}
                    >
                        Annuler
                    </Button>
                    <Button
                        variant={BUTTON_VARIANTS.REVERSE}
                        onClick={() => message.length === 0 ? null : handleReport(message)}
                    >
                        Envoyer
                    </Button>
                </Group>
            </div>
        </div>
    );
}
export default Report;